export default (props = {}) => ({
  /* border */
  [`bd-${props.bd}`]: props.bd,
  [`bd-${props.border}`]: props.border
});
